'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavigationUnfoldMore = function NavigationUnfoldMore(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
  );
};
NavigationUnfoldMore = (0, _pure2.default)(NavigationUnfoldMore);
NavigationUnfoldMore.displayName = 'NavigationUnfoldMore';
NavigationUnfoldMore.muiName = 'SvgIcon';

exports.default = NavigationUnfoldMore;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/navigation/unfold-more.js
// module id = 2575
// module chunks = 0